import {Component, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../../../store/reducers/admin-panel.reducer';
import {AdminPanelConfig} from '../../../admin-panel.config';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'lib-company-id-cell-viewer',
  templateUrl: './company-id-cell-viewer.component.html',
  styleUrls: ['./company-id-cell-viewer.component.scss']
})
export class CompanyIdCellViewerComponent implements CellComponent {
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  item: any;
  sourceType: string;
  valueChanged: EventEmitter<any>;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private store: Store<AdminPanelState>) {}

  redirectToDetail() {
    const companyId = this.item.cells.CompanyId.value;
    this.router.navigate(AdminPanelConfig.DetailCompanyUrl(companyId), {relativeTo: this.activatedRoute.parent});
  }

}
